import { css } from '@emotion/css'

const linkStyle = css`
    color: inherit;
    text-decoration: none;
    &:visited {
        color: inherit;
        text-decoration: none;
    }
    &[aria-disabled='true'] {
        color: #3f3f3f;
        cursor: default;
    }
    &:hover {
        text-decoration: underline;
    }
`

const isOperator = window.location.pathname.includes('/operator')
const isZone = window.location.pathname.includes('/zone')
const isStaking = window.location.pathname.includes('/staking')
const isManuscript = window.location.pathname.includes('/manuscript-studio')
const brandColor = '#FAFFC5'
const isTrench = window.location.pathname.includes('/trench')
const isBlockchains = window.location.pathname.includes('/blockchains')
const isRestricted = window.location.pathname.includes('/restricted')

const ABOUT_LIST = [
    {
        title: 'Blogs',
        url: 'https://blog.chainbase.com',
        logo: '/public/navbar/about_blogs_logo.png',
        img: '/public/navbar/product-1.png',
        subTitle: 'getting the latest posts',
    },
    {
        title: 'Community',
        url: '/community',
        logo: '/public/navbar/about_community_logo.png',
        img: '/public/navbar/product-2.png',
        subTitle: 'Connect with us',
    },
    {
        title: 'Ecosystem',
        url: '/ecosystem',
        logo: '/public/navbar/about_ecosystem_logo.png',
        img: '/public/navbar/product-3.png',
        subTitle: 'join us to be a chainbaser',
    },
    {
        title: 'About Us',
        url: '/about',
        logo: '/public/navbar/about_us_logo.png',
        img: '/public/navbar/product-4.png',
        subTitle: 'know more about us',
    },
]

const PRODUCT_LIST = [
    {
        title: 'Crypto Data Platform',
        url: 'https://platform.chainbase.com',
        logo: '/public/navbar/platform_logo.png',
        img: '/public/navbar/product-1.png',
        subTitle: 'the best crypto data service',
    },
    {
        title: 'Crypto World Model',
        url: 'https://chainbase.com/world-model',
        logo: '/public/navbar/theia_logo.png',
        img: '/public/navbar/product-2.png',
        subTitle: 'experience your crypto brain',
    },
    {
        title: 'Chainbase Genesis',
        url: 'https://genesis.chainbase.com',
        logo: '/public/navbar/genesis_logo.png',
        img: '/public/navbar/product-3.png',
        subTitle: 'chainbase community portal',
    },
]

const DEV_LIST = [
    {
        title: 'Run A Node',
        url: 'https://docs.chainbase.com/node/introduction',
        logo: '/public/navbar/develop_node_logo.png',
        img: '/public/navbar/product-1.png',
        subTitle: 'be an operator. the base of chainbase.',
    },
    {
        title: 'Manuscript',
        url: 'https://docs.chainbase.com/core-concepts/manuscript/overview',
        logo: '/public/navbar/develop_manuscript_logo.png',
        img: '/public/navbar/product-2.png',
        subTitle: 'creating a public aI world through data',
    },
    {
        title: 'Docs',
        url: 'https://docs.chainbase.com',
        logo: '/public/navbar/develop_docs_logo.png',
        img: '/public/navbar/product-3.png',
        subTitle: 'know more tech details',
    },
    {
        title: 'Network Explorer testnet',
        url: '/operator',
        logo: '/public/navbar/develop_operator_logo.png',
        img: '/public/navbar/product-4.png',
        subTitle: 'know more about the network status',
    },
]

const RESOURCE_LIST = [
    {
        title: 'Media kit',
        url: '/media-kit',
        logo: '/public/navbar/media_kit_logo.png',
        img: '/public/navbar/product-1.png',
        subTitle: 'the chainbase brand',
    },
    {
        title: 'Litepaper',
        url: 'https://github.com/chainbase-labs/chainbase-docs/blob/main/pdf/Chainbase_litepaper.pdf',
        logo: '/public/navbar/litepaper_logo.png',
        img: '/public/navbar/product-2.png',
        subTitle: 'our thoughts on public data',
    },
    {
        title: 'Contact Us',
        url: '/contact-us',
        logo: '/public/navbar/contact_us_logo.png',
        img: '/public/navbar/product-3.png',
        subTitle: 'let’s keep in touch',
    },
]

export default function Root() {
    return isTrench || isBlockchains ? null : isOperator || isZone || isStaking || isManuscript || isRestricted ? (
        <section
            className={css`
                background: #000;
                border-top: 2px solid #1a1a1a;
                text-transform: uppercase;
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding: 32px 75px;

                @media (max-width: 1280px) {
                    flex-direction: column-reverse;
                    gap: 1rem;
                    padding: 22px 48px;
                }

                @media (max-width: 768px) {
                    padding: 22px 0px;
                    flex-direction: column;
                }
            `}>
            {isRestricted ? (
                <div
                    className={css`
                        display: flex;
                        flex-direction: column;
                        gap: 9px;
                        @media (max-width: 1280px) {
                            align-items: center;
                        }
                    `}>
                    <img
                        className={css`
                            width: 179.341px;
                            height: 32px;
                        `}
                        src="/public/operator/chainbase-logo-gray.png"
                    />
                    <p
                        className={css`
                            color: #727272;
                            font-size: 16px;
                            font-weight: 500;
                            text-transform: uppercase;
                            letter-spacing: 1px;
                            text-align: center;

                            @media (max-width: 568px) {
                                font-size: 13px;
                            }
                        `}>
                        © 2025 Chainbase Foundation. All rights reserved
                    </p>
                </div>
            ) : (
                <img
                    className={css`
                        width: 179.341px;
                        height: 32px;
                    `}
                    src="/public/operator/chainbase-logo-gray.png"
                />
            )}

            <div
                className={css`
                    display: flex;
                    align-items: center;
                    text-transform: uppercase;
                    letter-spacing: -2px;
                    display: flex;
                    gap: 20px;

                    @media (max-width: 768px) {
                        flex-direction: column;
                        gap: 32px;
                    }
                `}>
                <div
                    className={css`
                        display: flex;
                        gap: 20px;
                    `}>
                    <BrandIcon name="x" link="https://x.com/ChainbaseHQ" brandColor={brandColor} />
                    <BrandIcon name="dicord" link="https://discord.com/invite/chainbase" brandColor={brandColor} />
                    <BrandIcon name="tg" link="https://t.me/ChainbaseNetwork" brandColor={brandColor} />
                    <BrandIcon name="lintree" link="https://linktr.ee/chainbasehq" brandColor={brandColor} />
                </div>
                {isRestricted ? null : (
                    <p
                        className={css`
                            color: #727272;
                            font-size: 16px;
                            font-weight: 500;
                            text-transform: uppercase;
                            letter-spacing: 1px;
                            text-align: center;

                            @media (max-width: 568px) {
                                font-size: 13px;
                            }
                        `}>
                        © 2025 Chainbase Foundation. All rights reserved
                    </p>
                )}
            </div>
        </section>
    ) : (
        <section
            className={css`
                background: #000;
                border-top: 2px solid #1a1a1a;
                text-transform: uppercase;
            `}>
            <div
                className={css`
                    display: flex;
                    height: 441px;
                    padding-left: 75px;
                    @media (max-width: 1024px) {
                        height: auto;
                        padding-left: 48px;
                    }
                    @media (max-width: 668px) {
                        flex-direction: column;
                        padding-left: 36px;
                    }
                `}>
                <div
                    className={css`
                        flex-grow: 1;
                        display: flex;
                        flex-direction: column;
                    `}>
                    <div
                        className={css`
                            display: flex;
                            flex-grow: 1;
                            gap: 96px;
                            @media (max-width: 1280px) {
                                gap: 48px;
                            }
                            @media (max-width: 1024px) {
                                display: grid;
                                grid-template-columns: repeat(2, 1fr);
                                row-gap: 16px;
                            }
                            @media (max-width: 568px) {
                                grid-template-columns: repeat(1, 1fr);
                                row-gap: 12px;
                            }
                        `}>
                        <LinkList>
                            <p>ABOUT</p>
                            {ABOUT_LIST.map((x) => (
                                <a className={linkStyle} href={x.url} target={x.url.startsWith('http') ? '_blank' : ''}>
                                    {x.title}
                                </a>
                            ))}
                        </LinkList>
                        <LinkList>
                            <p>PRODUCT</p>
                            {PRODUCT_LIST.map((x) => (
                                <a className={linkStyle} href={x.url} target={x.url.startsWith('http') ? '_blank' : ''}>
                                    {x.title}
                                </a>
                            ))}
                        </LinkList>
                        <LinkList>
                            <p>DEVELOPERS</p>
                            {DEV_LIST.map((x) => (
                                <a className={linkStyle} href={x.url} target={x.url.startsWith('http') ? '_blank' : ''}>
                                    {x.title}
                                </a>
                            ))}
                        </LinkList>
                        <LinkList>
                            <p>RESOURCES</p>
                            {RESOURCE_LIST.map((x) => (
                                <a className={linkStyle} href={x.url} target={x.url.startsWith('http') ? '_blank' : ''}>
                                    {x.title}
                                </a>
                            ))}
                        </LinkList>
                    </div>
                    <div
                        className={css`
                            height: 100px;
                            display: flex;
                            align-items: center;
                        `}>
                        <p
                            className={css`
                                color: #999;
                                font-size: 16px;
                                font-weight: 500;
                            `}>
                            Copyright © 2025 Chainbase Inc. All rights reserved
                        </p>
                    </div>
                </div>
                <div
                    className={css`
                        width: 441px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        border-left: 2px solid #1a1a1a;
                        @media (max-width: 1280px) {
                            width: 220px;
                        }
                        @media (max-width: 668px) {
                            border-left: unset;
                            width: 64px;
                        }
                    `}>
                    <img
                        src="/public/chainbase_horizontal_black_high.png"
                        className={css`
                            width: 233px;
                            height: 233px;
                            @media (max-width: 1280px) {
                                width: 170px;
                                height: 170px;
                            }
                            @media (max-width: 668px) {
                                width: 100%;
                                height: 100%;
                                margin-bottom: 24px;
                            }
                        `}
                    />
                </div>
            </div>
            <img
                src={
                    window.location.pathname === '/world-model'
                        ? '/public/footer/theia_footer.png'
                        : '/public/footer.png'
                }
                className={css`
                    width: 100%;
                `}
            />
        </section>
    )
}

function BrandIcon({ name, link, brandColor }: { name: string; link: string; brandColor: string }) {
    return (
        <div
            data-block="flare_button"
            onClick={() => window.open(link, '_blank')}
            className={css`
                position: relative;
                display: flex;
                align-items: center;
                justify-content: center;
                width: 48px;
                height: 48px;
                border-radius: 99px;
                overflow: hidden;
                background: #5c5c5c;
                cursor: pointer;
                @media (max-width: 768px) {
                    width: 32px;
                    height: 32px;
                }
            `}>
            <span
                className={
                    css`
                        &:before {
                            background-color: ${brandColor};
                            z-index: -1;
                        }
                    ` +
                    ' ' +
                    'button__flair'
                }></span>
            <img
                src={`/public/brand/${name}.png`}
                className={css`
                    position: relative;
                    z-index: 5;
                    width: 48px;
                    height: 48px;
                    @media (max-width: 768px) {
                        width: 32px;
                        height: 32px;
                    }
                `}
            />
        </div>
    )
}

function LinkList({ children }) {
    return (
        <div
            className={css`
                padding-top: 44px;
                width: fit-content;
                color: #e9e9e9;
                display: flex;
                flex-direction: column;
                & > p {
                    color: #5c5c5c;
                }
                & > a {
                    margin-top: 16px;
                    cursor: pointer;
                }

                @media (max-width: 1024px) {
                    padding-top: 16px;
                }
            `}>
            {children}
        </div>
    )
}
